<template>
    <div class="">
    </div>
</template>
<script>
 import {mapGetters, mapActions} from 'vuex'


    export default {
        components: {

        },
        data() {
            return {

            }
        },
        firestore() {
            return {

            }
        },
        methods: {
            ...mapActions([

            ])
        },
        computed: {
            ...mapGetters([
            ])
        },
        watch: {

        },
        created() {

        }
    }
</script>

<style lang="scss">

</style>